import { IMPORT_TOOL_ROUTE, getAvailableImportTools, hasImportToolAccess } from 'modules/importTool/importTool.constants';
import { Redirect, Route, Switch } from 'react-router-dom';
import ImportToolMenu from 'modules/importTool/importToolMenu.component';
import React from 'react';

// The import tool page lists the tools, and each tool has its own page under it. Users without import access go to the home
// page; unknown tool paths, and tools the user doesn't have the permission for, go back to the list.
const ImportToolLayout = () => {
  if (!hasImportToolAccess()) return <Redirect to="/" />;

  return (
    <Switch>
      <Route exact path={IMPORT_TOOL_ROUTE} component={ImportToolMenu} />
      {getAvailableImportTools().map(tool => (
        <Route key={tool.route} exact path={tool.route} component={tool.component} />
      ))}
      <Redirect to={IMPORT_TOOL_ROUTE} />
    </Switch>
  );
};

export default ImportToolLayout;
